import React from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import classNames from 'classnames';

import Logo from '../../../images/landing/Logo.svg';
import logo from '../../../images/Logo.png';
import sign from '../../../images/rayan.png';

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('headerStore')
@observer
export default class extends React.Component {
  static defaultProps = {};

  handleSidebar = () => {
    this.props.sideBarStore.activate();
  };

  handleIsLanding = (location) => {
    return location.pathname === '/' || location.pathname === '/pricing';
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if(this.props.location.pathname === '/' || this.props.location.pathname === '/pricing') {
      const el = document.getElementsByClassName('landing');
      const elPos = el[0].getBoundingClientRect();
      const wasScrolled = this.props.headerStore.isScrolled;

      if((elPos.top < -5) && !wasScrolled) {
        this.props.headerStore.scrolled();
      }

      if((elPos.top > -5) && wasScrolled) {
        this.props.headerStore.scrolled();
      }
    }
  };

  render() {
    const {location, userStore} = this.props;
    const activeSearch = this.props.headerStore.isActiveSearch;
    const wasScrolled = this.props.headerStore.isScrolled;
    const isLanding = this.handleIsLanding(location) && !userStore.user;

    return (
      <header className={classNames('main-header fixed-top', {
        'landing-header': isLanding,
        'is-scrolling': wasScrolled
      })}>
        <div className='row justify-content-between'>
          <NavLink
            className={classNames('logo', {'searchActive': activeSearch})}
            style={{paddingLeft: '15px'}}
            to={userStore.user ? '/' : '/'}>
            <img src={Logo} />
            <img src={logo} style={{ visibility: 'hidden', width: 0, height: 0 }} />
            <img src={sign} style={{ visibility: 'hidden', width: 0, height: 0 }} />
          </NavLink>
          {!userStore.user && (
            <div className='row'>
              <NavLink className="btn-new-white" to="/signIn">Log In</NavLink>
              <NavLink className="btn-new-main margin-left-20" to="/signUp">Create Account</NavLink>
            </div>
          )}
          {userStore.user && (
            <div className='row'>
              <NavLink to="/topic/">
                <span>Add New Topic</span>
              </NavLink>
              <NavLink to="/resources/add" className="margin-left-20">
                <span>Add New OSCE</span>
              </NavLink>
              <NavLink to="/resources/" className="margin-left-20">
                <span>OSCEs</span>
              </NavLink>
              <NavLink to="/mcq-themes/" className="margin-left-20">
                <span>MCQ Themes</span>
              </NavLink>
              <NavLink to="/mcq-questions/" className="margin-left-20">
                <span>MCQ Questions</span>
              </NavLink>
              <NavLink to="/sample-content/" className="margin-left-20">
                <span>Sample Content</span>
              </NavLink>
              <NavLink className="margin-left-20" to="/settings">My Account</NavLink>
            </div>
          )}
        </div>
      </header>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/core/containers/Header.js